<template>
    <v-list dense>
        <v-list-item-group>
            <v-list-item v-for="(item, i) in items" :key="i" :to="to(item.to)" @click="func(item.action)">
                <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list-item-group>
    </v-list>
</template>

<script>
    export default {
        name: "action-menu",
        props: {
            items: Object | Array,
            data: Object | Array
        },
        methods: {
            to(link) {
                return typeof link === 'undefined' ? '' : link;
            },
            func(action) {
                if (typeof action === 'undefined') {
                    return false;
                }
                this.$emit('echo', action);
            }
        }
    }
</script>

<style scoped>

</style>